import { graphql } from 'src/graphql';

import { TaskBlockFields } from 'containers/Studies/data/fragments/UnmoderatedTaskBlock.fragment';

/**
 * Notes:
 * - We set __typename on task_blocks in order to properly handle cache update especially when new task blocks are created
 */
export const UnmoderatedBooking = graphql(
  `
    query UnmoderatedBooking($id: ObjectID!) {
      unmoderatedBooking(_id: $id) {
        _id
        created
        updated
        name
        type
        status
        config {
          criteria {
            locations {
              countries {
                country
              }
            }
          }
          demo
          remote {
            askable_live
          }
          participant_agreement {
            type
          }
          question {
            _id
            title
            description
            config {
              display_participant
              multiple_selection
              none_of_the_above
              type
            }
            options {
              _id
              label
              screen_in
            }
          }
          options {
            review_submission
          }
          unmoderated {
            welcome_block {
              type
              title
              instructions
            }
            thank_you_block {
              type
              title
              instructions
            }
            recording_options {
              screen
              camera
              microphone
            }
            task_blocks {
              ...TaskBlockFields
            }
          }
        }
      }
    }
  `,
  [TaskBlockFields],
);
